import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    if (window.confirm('Çıkış yapmak istediğinize emin misiniz?')) {
      logout();
    }
  };

  return (
    <nav className="navigation">
      <Link
        to="/hybrid"
        className={`nav-link ${location.pathname === '/hybrid' ? 'active' : ''}`}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
          <path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2z"></path>
          <path d="M14 17v-3"></path>
          <path d="M10 17v-3"></path>
        </svg>
        Sorgu At
      </Link>
      <Link
        to="/aiprocess"
        className={`nav-link ${location.pathname === '/aiprocess' ? 'active' : ''}`}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
          <path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20"></path>
          <path d="M20 2H8a2 2 0 0 0-2 2v18"></path>
          <path d="M12 6h4"></path>
          <path d="M12 10h4"></path>
          <path d="M12 14h4"></path>
          <path d="M9 6h.01"></path>
          <path d="M9 10h.01"></path>
          <path d="M9 14h.01"></path>
        </svg>
        Yapay Zekâ Sorgusu
      </Link>
      <Link
        to="/history"
        className={`nav-link ${location.pathname === '/history' ? 'active' : ''}`}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <line x1="16" y1="13" x2="8" y2="13"></line>
          <line x1="16" y1="17" x2="8" y2="17"></line>
          <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
        Yapay Zekâ Hata Geçmişi
      </Link>
      <Link to="/selection-history" className={`nav-link ${location.pathname === '/selection-history' ? 'active' : ''}`}>
        Hata Açıklamaları ve Seçimler
      </Link>
      <Link to="/cluster-studies" className={`nav-link ${location.pathname === '/cluster-studies' ? 'active' : ''}`}>
        Hata Kümeleme
      </Link>
      <Link to="/cluster-review" className={`nav-link ${location.pathname === '/cluster-review' ? 'active' : ''}`}>
        Küme Değerlendirme
      </Link>
      <Link
        to="/groups"
        className={`nav-link ${location.pathname === '/groups' ? 'active' : ''}`}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
          <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
        </svg>
        Gruplar
      </Link>
      <Link
        to="/test"
        className={`nav-link ${location.pathname === '/test' ? 'active' : ''}`}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="9" y1="9" x2="15" y2="9"></line>
          <line x1="9" y1="15" x2="15" y2="15"></line>
        </svg>
        Hatalar
      </Link>
      {user && (
        <button type="button" className="nav-link nav-button" style={{ marginLeft: 'auto' }} onClick={handleLogout}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px', verticalAlign: 'middle' }}>
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          {user.username} |
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '8px', marginRight: '4px', verticalAlign: 'middle' }}>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          Çıkış
        </button>
      )}
    </nav>
  );
};

export default Navigation;
